// extracted by mini-css-extract-plugin
export default {"spinner":"Preloader_spinner__zNprh","rotation":"Preloader_rotation__YcQef"};